import React from "react";
import styles from "./InputField.module.scss"

const InputField = ({
    label,
  name,
  type = "text",
  value,
  onChange,
  placeholder,
  className = "",
  required = true,
  error
}) => {
  return (
    <div>
        <label htmlFor="label" className={styles.common_label}>{label}</label>
      <input
        type={type}
        name={name}
        id={name}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        required={required}
        className={styles.common_input}
        style={
            error
              ? {  border: "1px solid red" }
              : undefined
          }
          
      />
    </div>
  );
};

export default InputField;
